<template>

    <section>

        <!-- ここから -->

        <div class="md_404-component">
            <div class="title-wrap">
                <img src="/img/not-found.svg" alt="">
            </div>
            <div class="message-wrap">
                <p class="main">お探しのページは見つかりませんでした</p>
                <p class="sub">あなたがアクセスしようとしたページは、削除されているかURLが変更されているためお探しすることができませんでした。</p>
            </div>
        </div>

        <!-- BtnLinkWrap -->
        <div class="btn_link-wrap">

            <!--LinkBtn - 決定アイコン -->
            <Link class="btn_link md_icon-text _white" :href="route('admin.brand.dm.list')">
                <div class="inner">
                    <span><div class="icon"><SvgIconBack /></div>戻る</span>
                </div>
            </Link>

        </div><!-- /.BtnLinkWrap -->

        <!-- ここまで -->

    </section>

</template>

<script>
    import SvgIconBack from '@/components/EndUser/svg/SvgIconBack'

    export default {
        components: {
            //Svg
            SvgIconBack,
        },
    }
</script>
